import React from "react";

const LOGO_URL = "/vc-logo.jpg";

export default function Logo({ size = 28, className = "", showWordmark = false }) {
  return (
    <img
      src={LOGO_URL}
      alt="ViralCrew Logo"
      width={size}
      height={size}
      style={{ width: size, height: size, borderRadius: showWordmark ? 8 : 6, objectFit: "cover" }}
      className={className}
      loading="eager"
    />
  );
}
